module.exports = new __parcel__URL__("COVID-19_EUA_80777-291-09_PFS.7d32d5c9.jpg").toString();